import { useLocation } from 'react-router-dom';
import useStyles from '../../indexcss';

const AnswerHeader = () => {
  const location = useLocation();
  const { state } = location;
  const classes = useStyles();

  console.log('State from answer:', state);

  return (
    <>
      <div className={classes.subquestionHeader}>{state.subquestion}</div>
      <div className={classes.subHeaderQuestion}>Last updated 2 weeks ago</div>
    </>
  );
};

export default AnswerHeader;
